import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useAuthStore } from "@modules/auth/store/useAuthStore";
import { fetchUser } from "@core/libs/axios/services/authRequests";

// ── Owns: reactive user state only.
// ── login mutation lives exclusively in login/hooks/useLogin.ts
export function useAuth() {
  const { user, setUser } = useAuthStore();

  const userQuery = useQuery({
    queryKey: ["user"],
    queryFn: () => fetchUser(),
    enabled: false,
    retry: false,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (userQuery.data) {
      setUser(userQuery.data);
    }
  }, [userQuery.data, setUser]);

  const isAuthenticated = !!user || !!userQuery.data;
  const isLoadingUser = userQuery.isFetching;

  return {
    user: user || userQuery.data,
    isAuthenticated,
    isLoadingUser,
  };
}
